module.exports = __webpack_public_path__ + "static/media/blog-api-min.cf56cdda.png";